// extracted by mini-css-extract-plugin
module.exports = {"sections":"PortfolioNav-module--sections--11ubA","section":"PortfolioNav-module--section--1oVo1","active":"PortfolioNav-module--active--dWLDH"};